import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Ink from 'react-ink';
import { useSubmitLead } from '../../hooks/useSubmitLead';
import { trackEvents } from '../TrackEvents';
import { EmailInputContext } from '../../contexts/EmailInputContext';
import { showToast } from './Toast';
import { brandName } from 'utils/utils';
const LEAD_TYPE = 'premium';

const EmailInputComponent = ({
  id,
  className,
  acceptedTermsColor = 'text-[#1C2938]',
  acceptedTermsLinkColor = 'text-blue-900',
  buttonText = 'Claim Offer',
  buttonCustomClasses = 'bg-[#4FAB55]'
}) => {
  const {
    email, setEmail,
    acceptedTerms, setAcceptedTerms,
    buttonDisabled, setButtonDisabled
  } = useContext(EmailInputContext);
  const { submitLead, loading } = useSubmitLead();

  const brand = brandName(window.gon.current_brand)
  const brandSlug = window.gon.current_brand ? window.gon.current_brand : 'shipsticks';

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email) {
      return showToast('Please enter a valid email address.', 'error');
    }

    if (!acceptedTerms) {
      return showToast('Please accept the terms to proceed.', 'error');
    }

    setButtonDisabled(true);

    const response = await submitLead({
      email,
      campaignId: window.gon.campaign_id,
      campaignName: window.gon.campaign_name,
      acceptedTerms,
      leadType: LEAD_TYPE,
      source: 'premium'
    });

    if (response.success) {
      showToast(response.message, 'success');
      trackEvents(response, { email });
    } else {
      setButtonDisabled(false);
      showToast(response.message, 'error');
    }
  };

  return (
    <div className={className}>
      <div>
        <form
          onSubmit={handleSubmit}
          className="
            flex flex-col lg:h-[75px] sm:flex-row items-center sm:items-stretch p-2
            sm:bg-white sm:shadow-lg sm:rounded-full
          "
        >
          <div className="flex-1 text-left mb-2 sm:mb-0 bg-white w-full rounded-full sm:pt-1">
            <label htmlFor={`emailAddress-${id}`} className="hidden sm:block text-base font-medium text-[#1C2938] pl-6">
              Email Address
            </label>
            <input
              id={`emailAddress-${id}`}
              type="email"
              placeholder="email@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="
                w-full h-14 sm:h-auto pl-8 sm:pl-6 text-base font-normal text-[#1C2938] text-opacity-60
                bg-transparent focus:outline-none rounded-full
              "
              disabled={buttonDisabled}
            />
          </div>

          <button
            type="submit"
            className={`
              w-full sm:w-auto h-[59px] px-11 py-3 text-white font-medium
              text-lg rounded-full relative ${buttonCustomClasses} bg-${brandSlug}
              ${buttonDisabled || loading ? 'opacity-50 cursor-not-allowed' : ''}
            `}
            disabled={buttonDisabled || loading}
          >
            {buttonText}
            {!buttonDisabled && !loading && <Ink />}
          </button>
        </form>
      </div>
      <div className="w-full flex justify-center sm:w-auto mt-2 md:mt-4">
        <div className={
          id == 1 ? 'rounded-full bg-[#F8F9FB] bg-opacity-80 px-[10px] py-[6px] sm:px-4 sm:py-2' : 'text-center'
        }>
          <input
            id={`termAndConditionsCheckbox-${id}`}
            type="checkbox"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
            className="form-checkbox mt-2"
            disabled={buttonDisabled}
          />
          <label htmlFor={
            `termAndConditionsCheckbox-${id}`} className={`mt-2 ${acceptedTermsColor} text-xs sm:text-sm font-medium`
          }>
            &nbsp;&nbsp; I agree to {brand} &nbsp;
            <a className={
              `underline ${acceptedTermsLinkColor}`} href={window.origin + '/terms'
            } target="_blank" rel="noopener noreferrer">
              Terms of use
            </a>
            {' and '}
            <a className={
              `underline ${acceptedTermsLinkColor}`} href={window.origin + '/privacy'
            } target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>.
          </label>
        </div>
      </div>
    </div>
  );
};

EmailInputComponent.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  buttonBgColor: PropTypes.string,
  acceptedTermsColor: PropTypes.string,
  acceptedTermsLinkColor: PropTypes.string,
  buttonText: PropTypes.string,
  buttonCustomClasses: PropTypes.string
};

export default EmailInputComponent;
